export const UPDATE_INTERNAL_MARKETER_GRID_OFFSET = 'UPDATE_INTERNAL_MARKETER_GRID_OFFSET';
export type UPDATE_INTERNAL_MARKETER_GRID_OFFSET = typeof UPDATE_INTERNAL_MARKETER_GRID_OFFSET;
export interface UpdateInternalMarketerGridOffset {
    type: UPDATE_INTERNAL_MARKETER_GRID_OFFSET;
    offset: number;
}

export function updateInternalMarketerGridOffsetAction(offset: number): UpdateInternalMarketerGridOffset {
    return {
        type: UPDATE_INTERNAL_MARKETER_GRID_OFFSET,
        offset
    };
}
